import React, { useState } from 'react';
import { cn } from '@/utils/cn';
import { screenTypes, storeLocatorSearchTypes } from '@/constants/types';
import useWindowDimensions from '@/app/hooks/useWindowSize';
import { getSpecificStoreClipboardCopy } from '@/url/storeLocator';
import { copyToClipboard } from '@/utils';
import { useSelector } from 'react-redux';
import Icon from '../Icon';
import StoreLocatorTimeDetails from './StoreLocatorTimeDetails';
import HighlightText from '../Text/HighlightText';
import StoreLocatorShareButton from './StoreLocatorShareButton';
import TextSmall from '../Typography/TextSmall';
import TextSpan from '../Typography/TextSpan';
import DirectionOnMapButton from './DirectionOnMapButton';

function StoreLocatorCardBody({
  item,
  setIsOpenShareStoreLocationModal,
  isOpenShareStoreLocationModal,
  searchInput = '',
  fromStoreDetails = false,
  searchType = storeLocatorSearchTypes.default,
}) {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const { width: screenWidth } = useWindowDimensions();
  const { selectedDetailsStore } = useSelector((state) => state.storeLocator);

  const handleLinkClick = (event) => {
    event.stopPropagation();
    setIsOpenMenu(!isOpenMenu);
  };

  const handleClipboardCopy = (event, selectedItem) => {
    event.stopPropagation();
    if (selectedItem) {
      const { store_code } = selectedItem;
      const textToCopy = getSpecificStoreClipboardCopy({ store_code });
      copyToClipboard(textToCopy);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    }
  };

  return (
    <div className="store-locator-card-body space-y-[8px]">
      <div className="flex flex-col gap-[8px] mb-12">
        <div className="w-full flex justify-between">
          <HighlightText
            text={item.name}
            term={selectedDetailsStore ? null : searchInput}
            className="text-base font-semibold"
          />

          {searchType === storeLocatorSearchTypes.default ? (
            <StoreLocatorShareButton
              handleClipboardCopy={handleClipboardCopy}
              item={item}
              setIsOpenShareStoreLocationModal={
                setIsOpenShareStoreLocationModal
              }
              isOpenShareStoreLocationModal={isOpenShareStoreLocationModal}
              fromStoreDetails={fromStoreDetails}
              isCopied={isCopied}
            />
          ) : (
            <DirectionOnMapButton
              item={item}
              type={searchType}
              isDetails={selectedDetailsStore}
            />
          )}
        </div>

        <HighlightText
          text={item.address}
          term={selectedDetailsStore ? null : searchInput}
          className="text-xs lg:text-sm font-medium"
        />

        {searchType === storeLocatorSearchTypes.inStorePickup &&
        searchInput === '' ? (
          <>
            <TextSmall
              text="Distance:"
              className="font-semibold text-senate flex gap-x-1 items-center lg:hidden"
            >
              <TextSpan
                text={`Within ${item?.distance} ${item?.unit}`}
                className="font-medium"
              />
            </TextSmall>

            <TextSmall
              text={`Within ${item?.distance} ${item?.unit}`}
              className="font-medium hidden lg:flex"
            />
          </>
        ) : null}

        <TextSmall
          className={cn('text-coarse-wool font-medium', {
            'hidden lg:block':
              searchType === storeLocatorSearchTypes.inStorePickup &&
              !selectedDetailsStore,
          })}
        >
          <TextSpan text="Phone: " className="text-senate font-bold" />
          <TextSpan
            text={
              item?.phone && item?.phone?.length > 0
                ? item?.phone?.map((phone, i) => (
                    <span key={phone}>
                      {phone}
                      {i < item.phone.length - 1 ? ', ' : ''}
                    </span>
                  ))
                : null
            }
          />
        </TextSmall>

        <div
          role="presentation"
          className={cn('w-full flex flex-row items-start', {
            'hidden lg:flex':
              searchType === storeLocatorSearchTypes.inStorePickup &&
              !selectedDetailsStore,
          })}
          onClick={handleLinkClick}
        >
          <TextSmall
            text="Opening Hours: "
            className="flex-shrink-0 text-senate font-bold"
          />

          <div className="flex flex-col w-full overflow-x-hidden">
            <div className="flex flex-row items-center">
              <TextSmall
                text="See Details"
                className="flex-shrink-0 text-tealgreen font-bold ml-[12px] cursor-pointer"
              />

              <Icon
                type="angle-down"
                color="#00685F"
                className={cn(
                  ` transition duration-200 cursor-pointer size-4`,
                  {
                    'size-5': screenWidth >= screenTypes.large,
                  },
                  {
                    '!rotate-180 transition duration-200': isOpenMenu,
                  },
                )}
              />
            </div>

            <StoreLocatorTimeDetails isOpenMenu={isOpenMenu} item={item} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StoreLocatorCardBody;
